import React from 'react';
import "./Home.css";
import { Link } from 'react-router-dom';

import My from "../Video/My.mp4";

const Home = () => {
  
    return (
        <div className="MAIN">
            
            <h2><br/></h2>
            <div className="welcomebox">
            <div className="content">
            <header>Welcome to the Cave...</header>
            
            <div className="video">
                <video autoPlay loop muted>
                <source src={My} type="video/mp4"/>    
                </video>
            </div>

            </div>
            </div>
            <div className="descbox">
                <div className="descript">
                <p> We provide exclusive offers to exclusive games for a limited time for all types of consoles.Grab them ASAP! </p>
                <p>Browse our games through:<Link to="/Items"><a className="joint" >Here</a></Link></p>
                <p>Platforms available:</p>
                <div className="platforms">
                
                  {/*<img src="https://i.pinimg.com/originals/9a/ac/c8/9aacc8ea3abd27d912901049ac9b54db.png"/>*/} 
                  <img alt="Windows" src="https://www.freepnglogos.com/uploads/windows-logo-png/windows-logo-programming-language-19.png"/>  
                  <img alt="Play-Station" src="https://www.freepnglogos.com/uploads/playstation-png-logo/andtoid-playstation-png-logo-24.png"/>
                  <img alt="xbox" src="https://www.freepnglogos.com/uploads/xbox-png-images-free-download-xbox-gamepad-png-1.png"/>
                  {/*<img src="https://cdn.shopify.com/s/files/1/0298/8847/9276/products/paladone-i-usd-lamp-xbox-logo-light-15932539797548_2000x.jpg?v=1592896914"/>*/} 
                  <img alt="Ninteno-switch" src="http://imageform.se/wp-content/uploads/2017/02/Nintendo_Switch_Logo.svg_.png"/>
                  
                  
                </div>
                </div>
               
            </div>
            
            
            
         </div>
    )
}

export default Home
